<template lang="pug">
div
  template(v-if="!pageLoading")
    .sgbox.jl.aaa
      .gbox
        #preloader(v-if="gameLaunching")
          #loader
        div(v-if="!pageLoading")
          template(v-if="listToDisplay.length > 0")
            .ggl(v-if="game.game_code !== undefined" v-for="game in filteredList()")
              router-link(v-if="isLoggedIn" :to="'/launchOneapi?provider=JDB&game=' + game.game_code" target="_blank")
                VLazyImage(:src="game.game_image" src-placeholder="/images/fallb/JDB.png" @error="$helpers.handleImageError($event,'JDB')")
                span {{game.game_name}}
              a(v-else href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
                VLazyImage(:src="game.game_image" src-placeholder="/images/fallb/JDB.png" @error="$helpers.handleImageError($event,'JDB')")
                span {{game.game_name}}
              .progress
                .progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" :aria-valuenow='game.rtp' aria-valuemin="0" aria-valuemax="100" :style="'width: '+game.rtp+'%'") RTP {{game.rtp}}
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      offList:[],
      min: config.minE,
      max: config.max,
      precision: config.precision
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en-US"
        case "my":
          return "en-US"
        case "zh":
          return "zh-CN"
        default :
          return "en-US"
      }
    }
  },
  mounted(){
    // window.scroll(0,0)
    this.getProviderGameOfflist()
  },
  methods:{
    getProviderGameOfflist(){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "JDB"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
              this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
        this.getGameList()
      }
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
      var url = config.getOneapiList()
      this.$http.post(url, {
        "platform": "JDB",
        "gametype": "SLOT"
      }).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              var _0x59d9bc=_0x5cc9;function _0x5cc9(_0x3191df,_0x587c64){var _0xbfd390=_0xbfd3();return _0x5cc9=function(_0x5cc93e,_0x16eb43){_0x5cc93e=_0x5cc93e-0x163;var _0x3003e9=_0xbfd390[_0x5cc93e];return _0x3003e9;},_0x5cc9(_0x3191df,_0x587c64);}(function(_0x4f0f17,_0x854647){var _0x1c8616=_0x5cc9,_0x458300=_0x4f0f17();while(!![]){try{var _0xb9641=parseInt(_0x1c8616(0x169))/0x1+parseInt(_0x1c8616(0x168))/0x2*(-parseInt(_0x1c8616(0x16b))/0x3)+parseInt(_0x1c8616(0x166))/0x4+-parseInt(_0x1c8616(0x164))/0x5+-parseInt(_0x1c8616(0x163))/0x6+-parseInt(_0x1c8616(0x165))/0x7*(parseInt(_0x1c8616(0x16a))/0x8)+parseInt(_0x1c8616(0x16c))/0x9;if(_0xb9641===_0x854647)break;else _0x458300['push'](_0x458300['shift']());}catch(_0x4fd192){_0x458300['push'](_0x458300['shift']());}}}(_0xbfd3,0x65b5c),this[_0x59d9bc(0x167)]=successResponse[_0x59d9bc(0x16d)]);function _0xbfd3(){var _0x426fa0=['11110878CVmoHa','data','655080BPScvU','1644895swicLS','4095wErjlx','1842140SIhhdW','gameList','2DPYGae','21365woqPdR','608BfPNkd','2451657HTWEqM'];_0xbfd3=function(){return _0x426fa0;};return _0xbfd3();}
              eval(function(p,a,c,k,e,d){e=function(c){return c.toString(36)};if(!''.replace(/^/,String)){while(c--){d[c.toString(a)]=k[c]||c.toString(a)}k=[function(e){return d[e]}];e=function(){return'\\w+'};c=1};while(c--){if(k[c]){p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c])}}return p}('f.e.d(c(5){5["b"]=a((9.8()*(0.7-0.4)+0.4).3(0.6)*1).3(2)})',16,16,'vm|||toFixed|min|item|precision|max|random|Math|parseFloat|rtp|function|forEach|gameList|this'.split('|'),0,{}))
              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.game_code === obj2.game_id)
              )
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    launchGame(code){
      if (this.sessionToken) {
        this.gameLaunching = true
        var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = code
        let lang_code = this.getLanguage
        let provider = "JDB"
        this.$store
          .dispatch("user/launchOneapi", { player_id, auth_token,game_code, lang_code, provider })
          .then(response => {
            if (response.success == true) {
              setTimeout(() => {
                window.open(response.data, "_blank")
                vm.gameLaunching = false
              }) 
            } else {
              vm.gameLaunching = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), response.status, "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    // vm.$router.push("/slot").catch(error =>{})
                    vm.$store.dispatch("user/setSlotSelected", 0)
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), response.status, "info", this);
              }
            }
          });
      }else{
        this.$router.push('/login').catch(err => {})
      }
    },
    filteredList(){
      return this.listToDisplay.filter((game) =>
        game.game_name.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    }
  }
}
</script>